
import FadeIn from "../Animations/FadeIn";
import { ProductCardProps, getProductCardActions } from "../Types/ProductCardRenderingTypes";
import { Button } from "./Button";
import * as React from 'react'
import './CourseRender.css'
import { sanitizeChapterHtml } from "../Utils/sanitizeHtml";

export const ProductCard = (props: ProductCardProps) => {
  const actions = getProductCardActions(props.mode);
  const hasBanner = Boolean(props.bannerImage);
  const descriptionHtml = sanitizeChapterHtml(props.description);
  return (
    <FadeIn>
      <div className="product-card">
        {/* IMAGE */}
        <div className="product-card-image">
          {hasBanner ? (
            <img
              src={props.bannerImage}
              alt={props.title}
              className="product-card-image-img"
            />
          ) : (
            <div className="product-card-image-fallback">
              <span className="product-card-image-fallback-label">Kurspresentation</span>
              <strong>{props.title}</strong>
            </div>
          )}
          <div className="product-card-image-overlay" />
        </div>

        {/* CONTENT */}
        <div className="product-card-content">
          <div>
            <h3 className="product-card-title">{props.title}</h3>

            <div
              className="product-card-description"
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
            />
          </div>

          {/* FOOTER / CTA */}
          <div className="product-card-footer">
            {actions.showPrice && (
              <span className="product-card-price">{props.price} kr</span>
            )}

            <div className="product-card-actions">
              {actions.primaryText && (
                <Button
                  disabled={actions.disabled}
                onClick={props.onPrimaryAction}
                className="product-card-primary-btn"
                size="sm"
                text={actions.primaryText}
              />
              )}

              {actions.secondaryText && (
                <Button
                  variant="secondary"
                  onClick={props.onSecondaryAction}
                  text={actions.secondaryText}
                />
              )}
            </div>
          </div>
        </div>
      </div>

    </FadeIn>
  );
};
